const onEnterKeyPress = (e, fn) => {
  if (e.charCode === 13) {
    e.preventDefault()
    fn()
  }
}

export default onEnterKeyPress
